module.exports = __webpack_public_path__ + "static/media/close.c6c6850e.svg";